<template>
  <section class="popup">
     <div class="masker" v-if="isPopupShow">
      <form action="">
        <!-- 顶部标题部分 -->
        <div class="form_title">
           <s-title-header mainTitle='帮助中心' subTitle="管理" description="管理已创建的产品中心"></s-title-header>
        </div>
        <span>产品名称</span>
        <input type="text" placeholder="请输入产品名称"  maxlength="10" v-model="productName">
        <span>产品描述</span>
        <textarea name="" id="" cols="30" rows="10" maxlength="80" placeholder="请输入产品名称" v-model="productDes"></textarea>
        <div class="sel">
          <input class="square point"  type="checkbox"  v-model="isHidden"    name="pro"   />
          <span class="hide">是否隐藏</span>
        </div>

        <div class="pro_bottom">
          <span class=" cancle point" @click="hiddenClick">取消</span>
          <span class=" sure point" @click="saveProduct">确定</span>
        </div>
      </form>
    </div>
  </section>
</template>
<script>
import Api from '@/api/api'
import STitleHeader from '@/components/STitleHeader'
export default {
  /******************************************
  ** 组件名称
  * @description 组件描述
  * @author stone
  *****************************************
  prop1          <type>            <属性描述>
  *****************************************/
  name: 'component_name',
  components: {STitleHeader},
  props: {
    isPopupShow: {
      type: Boolean,
      require: true,
      default: false
    },
    proName: {
      type: String,
      default: ''
    },
    proDes: {
      type: String,
      default: ''
    },
    proId: {
      type: String,
      default: ''
    },
    proHidden: {
      type: Boolean,
      default: false
    }

  },
  data () {
    return {
      productName: '',
      productDes: '',
      isHidden: false

    }
  },
  computed: {},
  mounted () {
    this.productName = this.proName
    this.productDes = this.proDes
    this.isHidden = this.proHidden
  },
  methods: {
    // 点击取消
    hiddenClick () {
      this.$emit('changePopShow')
    },
    // 点击保存按钮
    saveProduct () {
      // console.log(1111111)
      if ($.trim(this.productName) === '') {
        alert('产品名称不能为空')
      } else if ($.trim(this.productDes) === '') {
        alert('产品描述不能为空')
      } else {
        // 如果产品名称不为空,就是保存修改信息
        if (this.proName) {
          this.saveUpdate()
          // 如果产品名称为空,调用创建产品来保存
        } else {
          this.saveInfo()
        }
      }
    },
    // 保存创建产品的信息
    saveInfo () {
      Api.createPro(this.productName, this.productDes, this.isHidden).then(res => {
        if (res.status === 200) {
          this.$emit('successCallback')
          this.productName = ''
          this.productDes = ''
          this.isHidden = false
        }
        this.$emit('changePopShow')
      }).catch(res => {
        alert('操作失败')
      })
    },
    // 保存修改
    saveUpdate () {
      Api.changePro(this.productName, this.productDes, this.proId, this.isHidden).then(res => {
        if (res.status === 200) {
          this.$emit('successCallback')
          this.productName = ''
          this.productDes = ''
          this.isHidden = false
          this.$emit('changePopShow')
        }
      }).catch(res => {
        alert('操作失败')
      })
    }

  }
}
</script>
<style lang="less" scoped>
.masker {
    position:fixed;
    width: 100%;
    height:100%;
     top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;

    form{
      width: 50%;
      position:relative;
      // padding:70px 35px 35px 35px;
      padding:0.35rem 0.18rem 0.18rem 0.18rem;
      background-color: #fff;
      border-radius: 12px;
      // color:#000;
      .form_title{
        // margin-bottom:40px;
        margin-bottom:0.2rem;
      }
      span,input {
        text-align: left;
        display: block;
        // color:#000;
      }
      span{
        // font-size: 14px;
        font-size:0.07rem;
        // margin-bottom:8px;
        margin-bottom:0.04rem;
      }
      input {
        // width: 2.03rem;
        width: 100%;
        // width: 406px;
        height: 0.2rem;
        // height: 40px;
        // line-height: 40px;
        line-height: 0.2rem;
        // padding-left:6px;
        padding-left:0.03rem;
        border: solid 1px #C0C0C0;
        border-radius:4px;
        // margin-bottom:10px;
        margin-bottom:0.05rem;
        // font-size: 12px;
        font-size:0.06rem;
        // color:#C0C0C0;
        box-sizing: border-box;
      }
      .sel{
        width: 100%;
        height: 0.2rem;
        line-height: 0.2rem;
        .square{
          display: inline-block;
          margin-bottom: 0;

          // position:absolute;
          // bottom:106px;
          // left:35px;
          // width:18px;
          width: 0.09rem;
          height: 0.06rem;
        }
        .hide{
          display: inline-block;
          margin-bottom:0;
          // position:absolute;
          // bottom:118px;
          // left:60px;
          // font-size: 10px;
          color:#7d7d7d;
          font-size:0.07rem;
        }

      }

      textarea {
        width: 100%;
        text-decoration: none;
        // width: 415px;
        // height: 121px;
        height: 0.6rem;
        padding:0.05rem 0.025rem;
        // padding:10px 5px 10px 5px;
        border: solid 1px #C0C0C0;
        border-radius:4px;
        box-sizing: border-box;
        // margin-bottom:80px;
        // margin-bottom:0.4rem;
        resize:none;
        font-size:0.06rem;
      }
      .pro_bottom{
        text-align: right;
        // font-size:12px;
        font-size:0.06rem;
        span{
          display:inline-block;
          // margin-right:10px;
          margin-right:0.05rem;
          // width:84px;
          width: 0.42rem;
          height: 0.14rem;
          line-height: 0.14rem;
          // height: 28px;
          // line-height: 28px;
          text-align: center;
          // border: solid 1px #276BEE ;
          border-radius:4px;
        }
        .cancle{
          font-size:0.06rem;
          color:#7d7d7d;
          background-color: #EAEAEA ;
        }
        .sure{
          font-size:0.06rem;
          color:#fff;
          background-color: #276BEE ;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Popup.vue